<template>
  <div class="new-address-section">
    <transition name="fade">
      <choose-address-coordinates
        v-if="showChooseCoordinatesDialog"
        :center="geocodeMode ? null : streetCoordinates"
        :with-geocode="geocodeMode"
        @close="closeMap"
        @save="saveCoordinatesFromMap"
      />
    </transition>
    <transition name="fade">
      <div v-show="!showChooseCoordinatesDialog">
        <!--        <h1 class="step-title font-weight-regular">-->
        <!--          Новый адрес:-->
        <!--        </h1>-->
        <div class="button-group d-flex justify-between">
          <v-row dense class="justify-space-between">
            <v-col sm="5">
              <v-btn
                :disabled="isLoading"
                class="button button-back"
                width="100%"
                color="#F1F3F6"
                @click="$emit('hide')"
              >
                <font-awesome-icon icon="chevron-left" />
                Вернуться назад
              </v-btn>
            </v-col>
            <v-col sm="5">
              <v-btn
                :loading="isLoading"
                :disabled="isSaveBtnDisabled"
                class="button button-apply"
                width="100%"
                color="#F1F3F6"
                @click="saveAddress"
              >
                <font-awesome-icon icon="check" />
                Сохранить адрес
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <div class="street-section">
          <v-row>
            <!--        <v-col sm="4">
          <div class="street-field">
            <span class="label">Город:</span>
            <city-input :init-val="region" @selected="handleCitySelect"/>
          </div>
        </v-col>-->
            <v-col sm="10">
              <div class="street-field">
                <span class="label">Город, поселок, улица:</span>
                <!-- v-show (не v-if): ref остаётся смонтирован, чтобы setModel работал при заполнении с карты -->
                <street-with-city-input
                  v-show="!manualAddressMode"
                  ref="streetInput"
                  v-model="streetFull"
                  :init-val="streetFull"
                  :disabled="isEdit"
                  @selected="onSelectStreet"
                  @choose-coordinates="openMapForStreet"
                />
                <div v-if="manualAddressMode" class="manual-address-fields">
                  <v-text-field
                    v-model="manualCity"
                    class="text-field"
                    label="Город"
                    :rules="[v => !!v || 'Укажите город']"
                    hide-details="auto"
                    flat
                    solo
                  />
                  <v-text-field
                    v-model="manualStreet"
                    class="text-field"
                    label="Улица"
                    :rules="[v => !!v || 'Укажите улицу']"
                    hide-details="auto"
                    flat
                    solo
                  />
                </div>
              </div>
            </v-col>
            <v-col sm="2">
              <span class="label">Дом<span class="label__extra">, корпус</span>:</span>
              <house-input
                ref="houseInput"
                v-model="house"
                :disabled="isHouseInputDisabled"
                :allow-manual="addressFromMap || manualAddressMode"
                :street-id="streetId"
                :init-val="house"
                @selected="onSelectHouse"
                @blur="checkAddress"
              />
            </v-col>
          </v-row>

          <v-row class="address-inputs">
            <v-col sm="3">
              <span class="label">Кв/офис:</span>
              <v-text-field
                v-model="apartmentNumber"
                hide-details="auto"
                class="text-field"
                flat
                solo
                @focus="currentKeyboard = 'apartment'"
              />
            </v-col>
            <v-col sm="3">
              <span class="label">Этаж:</span>
              <v-text-field
                v-model="floor"
                hide-details="auto"
                class="text-field"
                flat
                solo
                @focus="currentKeyboard = 'floor'"
              />
            </v-col>
            <v-col sm="3">
              <span class="label">Подъезд:</span>
              <v-text-field
                v-model="entry"
                hide-details="auto"
                class="text-field"
                flat
                solo
                @focus="currentKeyboard = 'entry'"
              />
            </v-col>
            <v-col sm="3">
              <span class="label">Домофон:</span>
              <v-text-field
                v-model="doorCode"
                hide-details="auto"
                class="text-field"
                flat
                solo
                @focus="currentKeyboard = 'entry'"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <span class="label">Филиал и зона доставки:</span>
              <address-filial-info
                :info="addressCheckResult"
                :error="addressCheckError"
                :loading="isLoadingCheckAddress"
                :point-lat="mapPointLat"
                :point-lng="mapPointLng"
                @choose-coordinates="openMapForFilial"
              />
            </v-col>
          </v-row>
        </div>
      </div>
    </transition>

    <!--    <choose-address-coordinates-dialog
      v-if="showChooseCoordinatesDialog"
      v-model="showChooseCoordinatesDialog"
      :center="streetCoordinates"
      @save="saveCoordinatesFromMap"
    />-->
  </div>
</template>

<script>
  import HouseInput from '@/components/ui/address/HouseInput.vue'
  import snackbarMessage from '@/mixins/snackbar-message'
  import _ from 'lodash'
  import AddressFilialInfo from '@/components/order-processing/order-components/address-window/AddressFilialInfo.vue'
  import StreetWithCityInput from '@/components/ui/address/StreetWithCityInput.vue'
  import ChooseAddressCoordinates from '@/components/order-processing/order-components/address-window/ChooseAddressCoordinates.vue'

  export default {
    name: 'NewAddressSection',
    emits: ['hide', 'new-address-created', 'address-edited'],
    components: {
      ChooseAddressCoordinates,
      StreetWithCityInput,
      AddressFilialInfo,
      HouseInput,
    },
    mixins: [snackbarMessage],
    props: {
      clientId: {
        type: Number,
        default: null,
      },
      editItem: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        isLoading: false,
        currentKeyboard: 'street',
        streetFull: '',
        house: '',
        apartment: '',
        apartmentNumber: '',
        floor: '',
        entry: '',
        doorCode: '',
        streetObj: {},
        houseObj: {},
        addressCheckError: null,
        addressCheckResult: null,
        isLoadingCheckAddress: false,
        showChooseCoordinatesDialog: false,
        saveAddressDisabled: false,
        geocodeMode: false,
        manualAddressMode: false,
        addressFromMap: false,
        manualCity: '',
        manualStreet: '',
      }
    },
    computed: {
      isEdit () {
        return !!this.editItem
      },
      isSaveBtnDisabled () {
        if (this.saveAddressDisabled || this.isLoadingCheckAddress) {
          return true
        }

        if (this.manualAddressMode && (!this.manualCity || !this.manualStreet)) {
          return true
        }

        return !this.addressCheckResult && !this.isEdit
      },
      isHouseInputDisabled () {
        // if (this.isEdit) {
        //   return true
        // }

        return _.isEmpty(this.streetObj)
      },
      city () {
        return this.manualAddressMode ? this.manualCity : this.streetObj?.city
      },
      street () {
        return this.manualAddressMode ? this.manualStreet : this.streetObj?.street
      },
      streetId () {
        return this.streetObj?.id
      },
      hasGeoData () {
        return !!this.houseObj?.hasGeo
      },
      fullStreetAddress () {
        if (this.manualAddressMode) {
          return [this.manualCity, this.manualStreet].filter(Boolean).join(', ')
        }
        return this.streetObj?.fullAddress || this.streetObj?.rawValue
      },
      fullHouseAddress () {
        return [this.fullStreetAddress, this.house].join(', ')
      },
      getLatitude () {
        return this.hasGeoData ? this.houseObj.latitude : null
      },
      getLongitude () {
        return this.hasGeoData ? this.houseObj.longitude : null
      },
      streetCoordinates () {
        return this.streetObj?.coordinates
      },
      // Координаты точки, поставленной на карте (успех/частично/ошибка геокодера) —
      // чтобы карта под формой показывала маркер даже без результата проверки зоны.
      mapPointLat () {
        return this.addressFromMap || this.manualAddressMode ? this.getLatitude : null
      },
      mapPointLng () {
        return this.addressFromMap || this.manualAddressMode ? this.getLongitude : null
      },
    },
    watch: {
      house (value) {
        if (this.addressFromMap || this.manualAddressMode) {
          // адрес с карты: координаты точки сохраняем, обновляем только номер дома
          if (this.houseObj && this.houseObj.value !== this.house) {
            this.houseObj = { ...this.houseObj, value: this.house }
            this.clearAddressCheck()
            this.checkAddressAfterInput()
          }
          return
        }
        if (this.houseObj && this.houseObj.value !== this.house) {
          this.clearHouseObj()
          this.clearAddressCheck()
          this.checkAddressAfterInput()
        }
      },
      streetFull (newValue) {
        console.log('watch street', this.streetObj, newValue)
        if (this.streetObj && this.streetObj.rawValue !== newValue) {
          console.log('watch street clear')
          this.clearStreetObj()
          this.clearHouseObj()
          this.clearAddressCheck()
          this.house = null
          this.addressFromMap = false
        }
      },
    },
    created () {
      if (this.editItem) {
        this.streetFull = this.editItem.city + ', ' + this.editItem.street
        this.apartmentNumber = this.editItem.apartmentNumber
        this.doorCode = this.editItem.doorCode
        this.house = this.editItem.house
        this.floor = this.editItem.floor
        this.entry = this.editItem.entry
      }
    },
    methods: {
      checkAddressAfterInput: _.debounce(function () {
        console.log('checkAddressAfterInput')
        this.checkAddress()
      }, 5000),
      checkAddress (force = false) {
        if (force) {
          this.clearAddressCheck()
        }
        if (
          this.isLoadingCheckAddress ||
          this.addressCheckError ||
          this.addressCheckResult ||
          !this.house
        ) {
          return
        }

        this.isLoadingCheckAddress = true
        const payload = {}
        if (this.hasGeoData) {
          payload.lat = this.houseObj.latitude
          payload.let = this.houseObj.longitude
        } else {
          payload.address = this.fullHouseAddress
        }

        this.$store
          .dispatch('suggests/checkAddressIsDeliveryByString', payload)
          .then((res) => {
            this.addressCheckResult = res.data
            if (res.data?.let && res.data?.lat) {
              this.setHouseCoordinates(res.data.lat, res.data?.let)
            }
          })
          .catch((err) => {
            this.addressCheckError =
            err?.response?.data?.message || 'Ошибка проверки адреса'
          })
          .finally(() => {
            this.isLoadingCheckAddress = false
          })
      },
      onSelectHouse (obj) {
        console.log({ selectHouse: obj })
        this.houseObj = obj || {}
        this.clearAddressCheck()
        this.checkAddress()
      },
      onSelectStreet (obj) {
        console.log({ selectStreet: obj })
        this.streetObj = obj
      },
      openMapForStreet () {
        this.geocodeMode = true
        this.showChooseCoordinatesDialog = true
      },
      openMapForFilial () {
        this.geocodeMode = false
        this.showChooseCoordinatesDialog = true
      },
      closeMap () {
        this.showChooseCoordinatesDialog = false
        this.geocodeMode = false
      },
      clearHouseObj () {
        this.houseObj = {}
      },
      clearAddressCheck () {
        this.addressCheckResult = null
        this.addressCheckError = null
        this.isLoadingCheckAddress = false
      },
      clearStreetObj () {
        this.streetObj = {}
        this.streetFull = null
        this.house = null
      },
      setHouseCoordinates (latitude, longitude, force = false) {
        if (latitude && longitude && (!this.hasGeoData || force)) {
          this.houseObj = {
            ...this.houseObj,
            hasGeo: true,
            latitude,
            longitude,
          }
          console.log('setHouseCoordinates', this.houseObj)
        }
      },
      saveCoordinatesFromMap (coords, address = null) {
        console.log('saveCoordinatesFromMap', coords, address)

        if (this.geocodeMode && address && address.street) {
          // успех/частично: заполняем поля из геокодера
          this.fillAddressFromGeocode(coords, address)
        } else if (this.geocodeMode) {
          // ошибка геокодера: ручной ввод города/улицы
          this.enableManualAddress(coords, address)
        } else {
          // старая кнопка филиала: только координаты
          this.setHouseCoordinates(coords[0], coords[1], true)
        }

        this.checkAddress(true)
        this.tempDisableSaveBtn()
      },
      fillAddressFromGeocode (coords, address) {
        const fullStreet = [address.city, address.street].filter(Boolean).join(', ')
        const house = address.house || ''

        this.manualAddressMode = false
        this.addressFromMap = true

        // ВАЖНО: streetObj/houseObj ставим ДО streetFull/house — watcher'ы сравнивают
        // rawValue/value и при совпадении НЕ сбрасывают только что заполненный объект.
        this.streetObj = {
          city: address.city,
          street: address.street,
          rawValue: fullStreet,
          fullAddress: [fullStreet, house].filter(Boolean).join(', '),
          coordinates: coords,
        }
        this.houseObj = {
          value: house,
          hasGeo: true,
          latitude: coords[0],
          longitude: coords[1],
        }
        this.streetFull = fullStreet
        this.house = house

        this.$nextTick(() => {
          if (this.$refs.streetInput) {
            this.$refs.streetInput.setModel(fullStreet)
          }
          if (this.$refs.houseInput) {
            this.$refs.houseInput.setModel(house)
          }
        })
      },
      enableManualAddress (coords, address) {
        this.addressFromMap = false
        this.manualAddressMode = true
        this.manualCity = (address && address.city) || ''
        this.manualStreet = ''
        this.streetObj = {}
        this.house = ''
        this.houseObj = {
          value: '',
          hasGeo: true,
          latitude: coords[0],
          longitude: coords[1],
        }
        this.$nextTick(() => {
          if (this.$refs.houseInput) {
            this.$refs.houseInput.setModel('')
          }
        })
        this.showErrorMessage(
          'Не удалось определить адрес по точке. Заполните город и улицу вручную.',
        )
      },
      tempDisableSaveBtn () {
        this.saveAddressDisabled = true
        setTimeout(() => {
          this.saveAddressDisabled = false
        }, 3000)
      },
      saveAddress () {
        this.isEdit ? this.editAddress() : this.addNewAddress()
      },
      async editAddress () {
        this.isLoading = true

        try {
          const data = {
            // city: this.editItem.city,
            // street: this.editItem.street,
            // house: this.editItem.house,
            apartmentNumber: this.apartmentNumber,
            entry: this.entry,
            floor: this.floor,
            houseFullAddress: this.editItem.fullAddress,
            latGeo: this.editItem.latGeo,
            letGeo: this.editItem.letGeo,
            doorCode: this.doorCode,
          }

          const id = this.editItem.id
          const res = await this.$store.dispatch('clients/editAddressClients', {
            data,
            id,
          })
          this.showSuccessMessage('Адрес отредактирован')
          this.$emit('hide')
          this.clearData()
          this.$emit('address-edited', id)
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.isLoading = false
      },
      async addNewAddress () {
        this.isLoading = true

        try {
          const data = {
            city: this.city,
            street: this.street,
            house: this.house,
            apartmentNumber: this.apartmentNumber,
            entry: this.entry,
            floor: this.floor,
            houseFullAddress: this.fullHouseAddress,
            latGeo: this.getLatitude,
            letGeo: this.getLongitude,
            doorCode: this.doorCode,
          }

          const id = this.clientId
          const res = await this.$store.dispatch('clients/addAddressClients', {
            data,
            id,
          })
          this.showSuccessMessage('Адрес создан')
          this.$emit('hide')
          this.clearData()
          this.$emit('new-address-created', res?.data?.id)
        } catch (err) {
          this.showErrorFromResponse(err)
        }
        this.isLoading = false
      },
      clearData () {
        this.currentKeyboard = 'street'
        this.house = ''
        this.apartment = ''
        this.apartmentNumber = ''
        this.floor = ''
        this.entry = ''
        this.suggests = []
        this.streetObj = {}
        this.houseObj = {}
        this.geocodeMode = false
        this.manualAddressMode = false
        this.addressFromMap = false
        this.manualCity = ''
        this.manualStreet = ''
      },
    },
  }
</script>

<style scoped lang="less">
.new-address-section {
  .step-title {
    font-size: 2.42em;
    line-height: 1;
    margin-bottom: 0.97em;
  }

  .button-group {
    margin-bottom: 21px;

    .button {
      height: 80px;
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;

      svg {
        margin-right: 8px;
      }
    }

    .button-back {
      border-radius: 10px;

      svg {
        .fill-svg(#0033ff);
      }
    }

    .button-apply {
      background-color: @color-success !important;
      color: #ffffff;
      border-radius: 10px;

      &.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        box-shadow: none !important;

        svg {
          .fill-svg(#00000042);
        }
      }

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  .label {
    display: block;
    font-size: 24px;
    line-height: 21px;
    margin-bottom: 25px;
  }

  // компактный десктоп: «Дом, корпус:» в узкой колонке не помещается в строку
  // и сдвигает поле вниз относительно соседнего - остаётся «Дом:»
  .media-compact-pc({
    .label__extra {
      display: none;
    }
  });

  .manual-address-fields {
    display: flex;
    flex-direction: row;
    gap: 14px;
  }

  .manual-address-fields > * {
    flex: 1 1 0;
  }

  .button-add {
    background-color: @color-primary !important;
    height: 6.7em;

    svg {
      width: 20px;
      height: 20px;
      margin-bottom: 12px;
    }
  }

  .region-select-field {
    cursor: pointer !important;

    ::v-deep {
      fieldset {
        border: none !important;
      }
    }
  }

  .text-field {
    &.v-input--is-focused {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }
    }

    ::v-deep {
      .v-input__slot {
        height: 80px;
        background-color: @color-secondary;
        border-radius: 15px;

        input {
          font-size: 20px;
          line-height: 18px;
          .media-xl({
            font-size: 25px;
            line-height: 18px;
          });
        }
      }
    }
  }

  ::v-deep {
    .city-input-component .input-text_input,
    .city-input-component .default-input,
    .house-input-component .input-text_input,
    .house-input-component .default-input,
    .street-input-component .input-text_input,
    .street-input-component .default-input {
      font-size: 20px;
      line-height: 18px;
      .media-xl({
        font-size: 25px;
        line-height: 18px;
      });
    }
  }

  .street-section {
    .streets {
      min-height: 104px;
    }

    .street-field {
      margin-bottom: 23px;
    }

    .label {
      display: block;
      margin-bottom: 14px;
      font-size: 20px;
      line-height: 21px;
    }

    .button {
      min-height: 80px;
      font-size: 24px;
      line-height: 18px;
      white-space: initial !important;
      background-color: @color-secondary !important;

      ::v-deep {
        .v-btn__content {
          display: block;
          word-break: break-all;
          width: 100%;
        }
      }
    }
  }
}
</style>
